"use client";

// Segment boundary for the public + marketing + sign-in group. The sign-in
// redirect chain passes through the home page (/), so a render crash during
// that soft-navigation lands here and degrades gracefully instead of showing
// the raw "Application error" screen.
import ErrorFallback from "@/components/shared/error-fallback";

export default function RootGroupError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorFallback error={error} reset={reset} />;
}
